/* Lo stato della pagina di un Paese (/paesi/[slug]) nell'indirizzo: testo,
   categoria, tipo di dispaccio e periodo (`?q`, `?cat`, `?tipo`, `?date`),
   come `FeedClient` e il Rullo. Niente `?page`: la pagina non si sfoglia,
   i dispacci si leggono nella finestra che scorre.

   Senza direttiva e senza import dal server: lo leggono la rotta (che lo
   ricava dall'indirizzo) e la ricerca, che è un Client Component. */

import { isPeriodo, type PeriodoKey } from "@/lib/constants";

/** Il tipo di dispaccio del menu: notizia, report o caso vengono dalla
 *  cronologia a monte (`tipoDerivato`). `esclusivi` (report **e** casi)
 *  non è nel menu: ci porta il rimando «Tutti i report e i casi» della
 *  scheda grande, e quando è acceso il menu lo mostra come voce in più. */
export type TipoFiltro = "" | "notizia" | "report" | "caso" | "esclusivi";

export const TIPI_MENU: { value: Exclude<TipoFiltro, "esclusivi">; label: string }[] = [
  { value: "", label: "Tutti i tipi" },
  { value: "notizia", label: "Notizia" },
  { value: "report", label: "Report" },
  { value: "caso", label: "Il caso" },
];

export const ETICHETTA_ESCLUSIVI = "Report e casi";

export type StatoPaese = {
  q: string;
  cat: string;
  tipo: TipoFiltro;
  date: PeriodoKey | "";
};

/** L'ancora della colonna dei dispacci, dove porta ogni filtro. */
export const ANCORA_DISPACCI = "dispacci";

function uno(v: string | string[] | undefined): string {
  return (Array.isArray(v) ? v[0] : v)?.trim() ?? "";
}

export function leggiStatoPaese(sp: { [k: string]: string | string[] | undefined }): StatoPaese {
  const tipo = uno(sp.tipo);
  const date = uno(sp.date);
  return {
    q: uno(sp.q).slice(0, 200),
    cat: uno(sp.cat).slice(0, 80),
    tipo: (["notizia", "report", "caso", "esclusivi"] as string[]).includes(tipo) ? (tipo as TipoFiltro) : "",
    date: isPeriodo(date) ? date : "",
  };
}

export function filtrato(s: StatoPaese): boolean {
  return Boolean(s.q || s.cat || s.tipo || s.date);
}

/** L'indirizzo della pagina con lo stato cambiato: le chiavi vuote
 *  escono dall'indirizzo, e si atterra sulla colonna dei dispacci. */
export function hrefPaese(slug: string, s: StatoPaese, modifiche: Partial<StatoPaese> = {}): string {
  const n = { ...s, ...modifiche };
  const p = new URLSearchParams();
  if (n.q) p.set("q", n.q);
  if (n.cat) p.set("cat", n.cat);
  if (n.tipo) p.set("tipo", n.tipo);
  if (n.date) p.set("date", n.date);
  const qs = p.toString();
  return `/paesi/${slug}${qs ? `?${qs}` : ""}`;
}
